module.exports = __webpack_public_path__ + "img/BARRY_120X35.10cc45ce.png";